import { CarouselNext, CarouselPrevious } from "components/ui/carousel";

const ImageSliderButtons = () => {
  return (
    <div className="absolute left-0 right-0 top-1/2 z-20 flex -translate-y-1/2 transform justify-between px-4">
      <CarouselPrevious
        iconClassName="!h-6 !w-6"
        className="!relative !left-auto !flex h-10 w-10 !translate-y-0 cursor-pointer items-center justify-center rounded-full border-gray-200 bg-white transition-colors hover:!bg-white  disabled:!bg-white"
      />
      <CarouselNext
        iconClassName="!h-6 !w-6"
        className="!relative !right-auto !flex h-10 w-10 !translate-y-0 cursor-pointer items-center justify-center rounded-full border-gray-200 bg-white transition-colors hover:!bg-white  disabled:!bg-white"
      />
    </div>
  );
};

export default ImageSliderButtons;
